export default __webpack_public_path__ + "static/media/9ea0a889f45bbaa2d2fb965c9e8d6347.svg";